import type { SummonKind } from "../../../data/portal-ffa-catalog";
import { portalFfaCatalog } from "../../../data/portal-ffa-catalog";
import type { SummonFailReason } from "../../../features/portal-ffa";
import { t } from "../../../data/strings";

export const MINIMAP_W = 112;
export const MINIMAP_H = 112;
export const ART_PACK = "portal-ffa";

export const ICON_MANA = `<svg class="ffa-res-svg" viewBox="0 0 16 16" aria-hidden="true"><path fill="#7ec8ff" d="M8 1.5 13.5 8 8 14.5 2.5 8Z"/></svg>`;
export const ICON_PRESERVE = `<svg class="ffa-res-svg" viewBox="0 0 16 16" aria-hidden="true"><path fill="#9aa3c7" d="M8 1.5 13 4v4.2c0 3.2-2.1 5.5-5 6.3-2.9-.8-5-3.1-5-6.3V4Z"/></svg>`;
export const ICON_SIGIL = `<svg class="ffa-res-svg" viewBox="0 0 16 16" aria-hidden="true"><path fill="#ffd27a" d="M8 1.2 9.6 5.8 14.4 6l-3.4 3.1 1.1 4.6L8 11.5 3.9 13.7l1.1-4.6L1.6 6l4.8-.2Z"/></svg>`;
export const ICON_QUEUE = `<svg class="ffa-res-svg" viewBox="0 0 16 16" aria-hidden="true"><rect x="2" y="3" width="12" height="2" rx="1" fill="#9aa3c7"/><rect x="2" y="7" width="9" height="2" rx="1" fill="#9aa3c7"/><rect x="2" y="11" width="11" height="2" rx="1" fill="#9aa3c7"/></svg>`;

export function failTitle(reason: SummonFailReason): string {
  return t(`hud.summonFail.${reason}`);
}

export function teamColorCss(teamId: number): string {
  const c =
    portalFfaCatalog.teamColors[teamId % portalFfaCatalog.teamColors.length] ??
    0xff3d7a;
  return `#${c.toString(16).padStart(6, "0")}`;
}

export function costHtml(kind: SummonKind): string {
  if (kind === "hero") {
    return `${ICON_SIGIL}<span>${portalFfaCatalog.units.hero.sigilCost}</span>`;
  }
  if (kind === "weapon") {
    return `${ICON_SIGIL}<span>${portalFfaCatalog.units.weapon.sigilCost}</span>`;
  }
  return `${ICON_MANA}<span>${portalFfaCatalog.units[kind].summonCost}</span>`;
}

export function topRegionHtml(): string {
  return `
    <div class="ffa-top-row">
      <div class="ffa-minimap-wrap" data-minimap-wrap>
        <canvas class="ffa-minimap" data-minimap width="${MINIMAP_W}" height="${MINIMAP_H}"></canvas>
        <div class="ffa-zoom-btns">
          <button type="button" class="ffa-zoom-btn" data-zoom-in aria-label="+">+</button>
          <button type="button" class="ffa-zoom-btn" data-zoom-out aria-label="-">−</button>
        </div>
      </div>
      <div class="ffa-top-info">
        <div class="ffa-ranks" data-ranks></div>
        <div class="ffa-meters">
          <div class="ffa-meter-row" data-mana></div>
          <div class="ffa-meter-row" data-sigil></div>
          <div class="ffa-msg" data-msg></div>
        </div>
      </div>
    </div>
  `;
}

export function midRegionHtml(): string {
  return `
    <div class="ffa-field-hit" data-field-hit></div>
  `;
}

export function deathModalHtml(): string {
  return `
    <div class="ffa-death-card">
      <h2>${t("hud.deathTitle")}</h2>
      <pre data-summary></pre>
      <button type="button" data-reenter class="menu-btn menu-btn-primary">${t("hud.reenter")}</button>
      <button type="button" data-quit class="menu-btn">${t("hud.quit")}</button>
    </div>
  `;
}
